var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.symbols),function(symbol){return _c('trading-view',{key:symbol,attrs:{"symbol":symbol}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }